import React, { useState, useEffect } from 'react';
import styles from './index.module.scss';
import { Radio, Space } from 'antd-mobile-v5'
interface Person {
    id: string;
    name: string;
    phone: string;
    txr: string;
    xs: string;
    xb: string;
    jycb: string;
    jzcs: string;
    editModel: any;
}

interface PersonInfoProps extends Person {
    onChange?: ({ (value: string, key: string): void})
}

const PersonInfo = (props: PersonInfoProps) => {
    
    const [ person, setPerson ] = useState({
        id: '',
        name: '',
        phone: '',
        txr: '',
        xs: '',
        xb: '',
        jycb: '',
        jzcs: ''
    })
    const [ phone, setPhone ] = useState('')
    //受试者名称
    const targetName = sessionStorage.getItem('targetName') || '受试者';
    useEffect(() => {
        const originUrlParam = localStorage.getItem('OriginUrlParam');
        if (originUrlParam) {
            const _originUrlParam = JSON.parse(originUrlParam);
            if (_originUrlParam.phone) {
                setPhone(_originUrlParam.phone)
            }
        }
    }, [])

    useEffect(() =>{
        setPerson({
            id: props?.id,
            name: props?.name,
            phone: props?.phone,
            txr: props?.txr,
            xs: props?.xs,
            xb: props?.xb,
            jycb :props?.jycb,
            jzcs: props?.jzcs
        })
    }, [props])

    const handleChange = (value: string, key: string) => {
        props.onChange && props.onChange(value, key)
    }

    const handleNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        handleChange(e.currentTarget?.value, 'name')
    }

    const handlePhoneChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        handleChange(e.currentTarget?.value, 'phone')
    }

    return (
        <div className={styles.personInfoCard}>
            <div className={styles.cardTitle}>个人信息</div>
            <form className={styles.personForm}>
                <div className={styles.formItem}>
                    <div className={styles.formItemLabel}>{props.editModel === 1?'患者':'受试者'}编码</div>
                    <div className={styles.formItemContent}>{props.id}</div>
                </div>
                {
                   props.editModel !== 1 &&
                   <div className={styles.formItem}>
                        <div className={styles.formItemLabel}>姓名首字母大写</div>
                        <div className={styles.formItemContent}>
                            <input
                                className={`${styles.input}`}
                                placeholder="请输入姓名首字母大写"
                                type="text"
                                value={props.name}
                                onChange={handleNameChange}
                            />
                        </div>
                    </div>
                }
              
                
                <div className={styles.formItem}>
                    <div className={styles.formItemLabel}>手机号</div>
                    <div className={styles.formItemContent}>
                        <input
                            className={`${styles.input}`}
                            readOnly
                            type="text"
                            value={phone}
                        />
                    </div>
                </div>
                {/* <div className={styles.formItem}>
                    <div className={styles.formItemLabel}>手机号</div>
                    <div className={styles.formItemContent}>
                        <input
                            className={`${styles.input}`}
                            placeholder="请输入手机号"
                            type="text"
                            value={props.phone}
                            onChange={handlePhoneChange}
                        />
                    </div>
                </div> */}

                {
                   props.editModel === 1 && 
                   <div className={styles.formItem}>
                        <div className={styles.formItemLabel}>本人还是家属</div>
                        <div className={styles.formItemContent} >
                            <Radio.Group value={props.txr}    
                                onChange={(e : any)=>{handleChange(e, 'txr') }}
                             >
                                <Radio value='1'>本人</Radio>
                                <Radio value='2'>家属</Radio>
                            </Radio.Group>
                        </div>
                    </div>
                }
                   
              {
                   
                   props.editModel === 1 && 
                   <div className={styles.formItem}>
                        <div className={styles.formItemLabel}>姓名</div>
                        <div className={styles.formItemContent}>
                            <input
                                className={`${styles.input}`}
                                placeholder="请输入姓名"
                                type="text"
                                value={props.xs}
                                maxLength={20}
                                onChange={(e)=>{handleChange(e.currentTarget?.value, 'xs')}}
                            />
                        </div>
                    </div>
                }

                {
                    props.editModel === 1 && 
                     <div className={styles.formItem}>
                        <div className={styles.formItemLabel}>性别</div>
                        <div className={styles.formItemContent}>
                        <Radio.Group value={props.xb}  onChange={(e : any)=>{
                             handleChange(e, 'xb')
                        }}>
                                <Radio value='1'>男</Radio>
                                <Radio value='2'>女</Radio>
                           
                            </Radio.Group>
                        </div>
                    </div>
                }
                {
                    props.editModel === 1 && 
                     <div className={styles.formItem}>
                        <div className={styles.formItemLabel}>受教育程度</div>
                        <div className={styles.formItemContent}>
                        <Radio.Group value={props.jycb}  onChange={(e : any)=>{
                             handleChange(e, 'jycb')
                        }}>
                                <Radio value='1'>文盲</Radio>
                                <Radio value='2'>小学</Radio>
                                <Radio value='3'>初中</Radio>
                                <Radio value='4'>高中</Radio>
                                <Radio value='5'>大学</Radio>
                                <Radio value='6'>研究生及以上</Radio>
                           
                            </Radio.Group>
                        </div>
                    </div>
                }
                 {
                   
                   props.editModel === 1 && 
                   <div className={styles.formItem}>
                        <div className={styles.formItemLabel}>居住城市</div>
                        <div className={styles.formItemContent}>
                            <input
                                className={`${styles.input}`}
                                placeholder="请输入居住城市"
                                type="text"
                                value={props.jzcs}
                                maxLength={20}
                                onChange={(e)=>{handleChange(e.currentTarget?.value, 'jzcs')}}
                            />
                        </div>
                    </div>
                }
            </form>
        </div>
    )
}

export default PersonInfo